import { Trans } from '@lingui/macro';
import { Box, FormControlLabel, Switch } from '@mui/material';
import { toggleLocalStorageClick } from '../../helpers/toggleLocalStorageClick';
import { NetworkConfig } from '../../ui-config/networksConfig';

interface DashboardListTopPanelProps extends Pick<NetworkConfig, 'bridge'> {
  value: boolean;
  onClick: (value: boolean) => void;
  localStorageName: string;
}

export const DashboardListTopPanel = ({
  value,
  onClick,
  localStorageName,
}: DashboardListTopPanelProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: { xs: 'flex-start', xsm: 'center' },
        justifyContent: 'space-between',
        flexDirection: { xs: 'column-reverse', xsm: 'row' },
        px: { xs: 4, xsm: 6 },
        py: { xs: 0, xsm: 2 },
        pl: { xs: '18px', xsm: '27px' },
        ml: { xs: 1, md: 0 }
      }}
    >
      <FormControlLabel
        control={<Switch sx={{ p: '6px' }} />}
        checked={value}
        onChange={() => {
          toggleLocalStorageClick(value, onClick, localStorageName);
        }}
        label={<Trans>Hide zero balances</Trans>}
      />

      {/*{(STAGING_ENV || ENABLE_TESTNET) && <FaucetButton />}*/}
    </Box>
  );
};
